import React from 'react';
import { appElement } from '@opengov/compose-app/renderApp';
import ReactDOM from 'react-dom';
import { App } from './module/routes/App';

ReactDOM.render(<App />, appElement);

if (module.hot) {
  module.hot.accept(() => {});
}
